import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule as BootstrapModalModule } from 'ngx-bootstrap/modal';

import { ModalComponent } from './modal.component';

@NgModule({
    imports: [CommonModule, TranslateModule, BootstrapModalModule.forRoot()],
    declarations: [ModalComponent]
})
export class ModalModule {}
